import { SyntheticEvent } from 'react';

const actionSelector = 'a, area, button, input, select, textarea, form, [role="button"], [role="link"]';

// Work on the rendered preview copy only, never the template or send payload.
export function inertEmailPreviewHtml(html: string): string {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('a[href], a[xlink\\:href]').forEach((link) => {
    link.setAttribute('data-email-preview-link', '');
  });
  doc.querySelectorAll(actionSelector).forEach((element) => {
    ['href', 'xlink:href', 'target', 'download', 'ping', 'action', 'formaction', 'formtarget', 'autofocus'].forEach((attribute) => element.removeAttribute(attribute));
    Array.from(element.attributes).forEach((attribute) => {
      if (attribute.name.startsWith('on')) element.removeAttribute(attribute.name);
    });
    element.setAttribute('tabindex', '-1');
    element.setAttribute('aria-disabled', 'true');
    if (element.tagName === 'BUTTON' || (element.tagName === 'INPUT' && /^(submit|image|reset)$/i.test(element.getAttribute('type') || ''))) {
      element.setAttribute('type', 'button');
    }
    if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') element.setAttribute('readonly', '');
  });
  doc.querySelectorAll('meta[http-equiv]').forEach((meta) => {
    if (meta.getAttribute('http-equiv')?.toLowerCase() === 'refresh') meta.remove();
  });
  // Retain ordinary link presentation; existing template CSS/inline styles win.
  const style = doc.createElement('style');
  style.textContent = ':where(a[data-email-preview-link]) { color: LinkText; text-decoration: underline; }';
  doc.head.prepend(style);
  return `<!doctype html>${doc.documentElement.outerHTML}`;
}

function preventActivation(event: Event) {
  const target = event.target as Element | null;
  if (event.type !== 'submit' && !target?.closest?.(actionSelector)) return;
  if (event.type === 'keydown' && !['Enter', ' '].includes((event as KeyboardEvent).key)) return;
  event.preventDefault();
}

// The existing script-free same-origin sandbox permits parent-owned listeners.
// Do not block pointer events on the iframe: scrolling/selection stay available.
export function inertEmailPreviewOnLoad(event: SyntheticEvent<HTMLIFrameElement>) {
  const doc = event.currentTarget.contentDocument;
  if (!doc) return;
  ['click', 'auxclick', 'submit', 'keydown'].forEach((type) => {
    doc.addEventListener(type, preventActivation, true);
  });
}
